import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MonitoringPreferencesService } from '../../core/services/monitoring-preferences.service';

/** A response started in an old account/building/selection must never repopulate a view. */
export const monitoringScopeInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method !== 'GET' || !request.url.startsWith(environment.apiEndpoint + '/')) return next(request);
  const path = request.url.slice(environment.apiEndpoint.length);
  if (!/^\/(facilities|iot-devices|notifications|analytics|bed-states)(\/|\?|$)/.test(path)) return next(request);
  const preferences = inject(MonitoringPreferencesService);
  return next(request).pipe(takeUntil(preferences.invalidated$));
};
